import React from 'react'
import Reflux from 'reflux'
// import { Container, Row, Col, ListGroup, ListGroupItem, Form, FormGroup, Input, Button, Badge, Label } from 'reactstrap'
import { Container, Row, Col, ListGroup, ListGroupItem, Form, Input, Button, Badge, Label } from 'reactstrap'
import _ from 'lodash'

import RecipesActions from '~/actions/recipes.js'
import RecipesStore from '~/stores/recipes.js'

import FiltersActions from '~/actions/filters.js'
import FiltersStore from '~/stores/filters.js'

import CategoriesStore from '~/stores/categories.js'

// import CategoryLabel from '~/modules/categoryLabel/index.jsx'
import RecipeListItem from './item.jsx'


export default class RecipeList extends Reflux.Component {
	constructor(props) {
		super(props)

		this.stores = [RecipesStore, FiltersStore, CategoriesStore]

		this.state = {
			list: null,
			categoryID: 0,
			categories: [],
			text: ''
		}
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	componentDidMount() {
		RecipesActions.get()
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	render() {
		const theListWithCategoryFilter = (this.state.categoryID > 0)
			? _.filter(this.state.list, { categoryID: this.state.categoryID })
			: this.state.list
		const theListWithTextFilter = (this.state.text !== '')
			? _.filter(theListWithCategoryFilter, obj =>
				obj.recipe.toLowerCase().indexOf(this.state.text.toLowerCase()) === 0
			)
			: theListWithCategoryFilter
		const isLoaded = (this.state.list !== null)
		const theList = (isLoaded)
			? theListWithTextFilter.map(theRecipe =>
				<Col md={4} xl={3} key={theRecipe.recipeID} className="padRowWrapping" style={{ paddingBottom: '1em !important' }}>
					<RecipeListItem item={theRecipe} />
				</Col>
			)
			: null
		const theRecipes = (_.size(theList) > 0)
			? theList
			: <div>{ 'No recipes found' }</div>
		const arrAllCategories = _.cloneDeep(this.state.categories)

		// add the ALL option
		arrAllCategories.unshift(
			{
				category: 'All Categories',
				categoryID: 0,
				recipesInCategoryCount: _.size(this.state.list)
			}
		)

		const categoriesButtons = arrAllCategories.map((category) => {
			const itemProps = {}

			if (this.state.categoryID === category.categoryID) {
				itemProps.active = true
			}

			return (category.recipesInCategoryCount > 0)
				? (
					<ListGroupItem
						color="link"
						key={category.categoryID}
						value={category.categoryID}
						onClick={RecipeList.setFilterCategory}
						style={{ cursor: 'pointer' }}
						{...itemProps}
					>
						{category.category}
						<Badge className="float-right" color="dark">
							{ category.recipesInCategoryCount }
						</Badge>
					</ListGroupItem>
				)
				: null
		})

		let theContent = <div>Loading recipes...</div>

		if (isLoaded) {
			theContent = (
				<Container fluid>
					<Row>
						{ theRecipes }
					</Row>
				</Container>
			)
		}

		return (
			<Container fluid>
				<Row>
					<Col lg={3}>
						<ListGroup>
							{ categoriesButtons }
						</ListGroup>
					</Col>
					<Col>
						<Form inline>
							<Label className="mr-sm-1" for="filterName">Filter:</Label>
							<Input className="mr-sm-3" bsSize="sm" id="filterName" type="text" onChange={RecipeList.setFilterText} value={this.state.text} />
							<Button size="sm" color="primary" onClick={RecipeList.resetFilters}>Reset</Button>
						</Form>

						<br />

						{ theContent }
					</Col>
				</Row>
			</Container>
		)
	}

	static setFilterCategory(event) {
		event.preventDefault()

		FiltersActions.setCategory(parseInt(event.target.value, 10))
	}

	static setFilterText(event) {
		event.preventDefault()

		FiltersActions.setText(event.target.value)
	}

	static resetFilters(event) {
		event.preventDefault()

		FiltersActions.reset()
	}
}



// WEBPACK FOOTER //
// ./src/modules/list/index.jsx